import { Box } from '@mui/material'
import AIResponseLoadingGIF from '../../assets/loaders/adnoc-loading.gif';

function AdnocLoadingProgress() {
  return (
    <Box sx={{
      width: '100%',
      height: '64px',
      display: 'grid',
      placeContent: 'center',
      justifyItems: 'center'
    }}>
      <img
        src={AIResponseLoadingGIF}
        alt='.'
        style={{
          width: '56px',
          aspectRatio: 1 / 1
        }}></img>
    </Box>
  )
}

export default AdnocLoadingProgress